import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

import TerminalLoginPage from "../../features/terminal-auth/pages/TerminalLoginPage";
import TerminalPasswordResetRequestPage from "../../features/terminal-auth/pages/TerminalPasswordResetRequestPage";
import TerminalSelectBranchPage from "../../features/terminal-auth/pages/TerminalSelectBranchPage";
import AttendanceTerminalPage from "../../features/terminal-attendance/pages/AttendanceTerminalPage";

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/attendance" replace />} />

      <Route path="/login" element={<TerminalLoginPage />} />
      <Route
        path="/password-reset/request"
        element={<TerminalPasswordResetRequestPage />}
      />

      <Route
        path="/select-branch"
        element={
          <ProtectedRoute>
            <TerminalSelectBranchPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/attendance"
        element={
          <ProtectedRoute>
            <AttendanceTerminalPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/attendance" replace />} />
    </Routes>
  );
}